import { Pipe, PipeTransform } from '@angular/core';
import { gfUtcDateFunction } from './date.functions';

@Pipe({
    name: 'gfUtcDate'
})
export class DateGfUtcDatePipe implements PipeTransform {
    transform(inputValue?: string, format?: string, locale?: string): any {
        return gfUtcDateFunction(inputValue, format, locale);
    }
};